import { render, staticRenderFns } from "./MaydayNodeMainFooter.vue?vue&type=template&id=b73b4b80&scoped=true&"
import script from "./MaydayNodeMainFooter.vue?vue&type=script&lang=js&"
export * from "./MaydayNodeMainFooter.vue?vue&type=script&lang=js&"
import style0 from "./MaydayNodeMainFooter.vue?vue&type=style&index=0&id=b73b4b80&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b73b4b80",
  null
  
)

export default component.exports